<template>
  <div>
    <div class="text-dark">
      第二步，请使用USDT进行支付
    </div>
    <div class="p2" style="font-size: 14px">
      付款时请务必分毫不差付款二维码上方显示的金额（不含矿工费）。
    </div>
    <div class="m2">
      <el-button plain v-for="item of tableData" @click="Category(item.id,item.title)" :key="item.points" style="margin: 5px">
        {{item.title}}{{parseInt(item.price*0.95)}}元
      </el-button>
    </div>
    <div class="text-dark">
      第三步，等待区块链确认到账
    </div>
    <div style="font-size: 14px">区块链确认完成，将会为你更新会员等级，请在「会员中心」查看。</div>
    <el-dialog title="请选择USDT链" :visible.sync="dialogTableVisible" :lock-scroll="false">
      <div class="container___rRDCW ">
        <div class="body___3IrP1">
          <div class="select_card___3LVj_"  @click="select_token('0', 'TRC20')">
            <div class="left___3KHaw">
              <div class="Icon">
                <svg-icon icon-class="trc"></svg-icon>
              </div>
            </div>
            <div class="right___1QBlH">TRC20-USDT
              <div class="description___15tno">安全</div>
            </div>
          </div>
<!--          <div class="select_card___3LVj_"  @click="select_token('1', 'ERC20')">-->
<!--            <div class="left___3KHaw">-->
<!--              <div class="Icon">-->
<!--                <svg-icon icon-class="eth-usdt"></svg-icon>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right___1QBlH">ERC20-USDT-->
<!--              <div class="description___15tno">安全</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="footer___m_FDZ"></div>
      </div>
    </el-dialog>
    <el-dialog title="收银台"
               :close-on-click-modal="false"
               :visible.sync="paydialogTableVisible"
               @close='closeQR'
               :lock-scroll="false">
        <div v-loading="loading" style="height: 470px; overflow: auto; text-align: center; user-select: auto">
          <div v-show="loadqr">
            <div class="text-dark-usdt">
              {{this.amount}} USDT
            </div>
            <div class="des">请扫描二维码或复制地址支付</div>
            <div id="qrcode" class="qr_card___2sKl3" ref="qrcode"></div>
            <div class="p4 Icon" style="cursor:pointer" v-clipboard:copy="address" v-clipboard:success="onCopy" v-clipboard:error="onError">{{this.address}}
              <svg-icon icon-class="copy" style="width: 1rem; height: 1rem; color: #f39"></svg-icon>
            </div>
            <div class="p5">* 点击↑上方，复制地址</div>
            <div class="p5">* 您正在使用「<b class="p4">{{ this.token_name}}-USDT</b>」进行付款</div>
            <div class="p5" v-if="!loading">* 付款时请务必支付【<b class="p4">{{this.amount}}U</b>】，不含手续费</div>
            <el-button style="margin-top: 10px" @click="pay_success">我已支付</el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import {request} from '../../network/request'
export default {
  name: 'paytoken',
  data () {
    return {
      paydialogTableVisible: false,
      dialogTableVisible: false,
      currency: '',
      cid: -1,
      title: '',
      fullscreenLoading: false,
      token: '',
      address: '',
      amount: '',
      token_name: '',
      loading: true,
      qrcode: '',
      loadqr: false
    }
  },
  props: {
    tableData: {}
  },
  methods: {
    pay_success () {
      this.$alert('USDT支付需要等待5-10分钟的确认。如果你已支付，可以关闭该页面，系统将在区块链确认后自动为您开通会员。', '提醒', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        lockScroll: false,
        callback: action => {
        }
      })
    },
    onCopy () {
      this.$message.success('复制成功')
    },
    onError () {
      this.$message.console.error('复制失败')
    },
    closeQR () {
      document.getElementById('qrcode').innerText = ''
    },
    creatQrCode (code) {
      document.getElementById('qrcode').innerText = ''
      this.qrcode = new QRCode('qrcode', {
        text: code, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff'
      })
    },
    gettokenQR () {
      let data = new URLSearchParams()
      data.append('cid', this.cid)
      data.append('token', this.token)
      request({
        url: '/api/gettoken',
        method: 'post',
        data: data
      }).then(res => {
        this.amount = res.data['price']
        this.address = res.data['address']
        this.creatQrCode(res.data['address'])
        this.loading = false
        this.loadqr = true
      }).catch(err => {
        console.log(err)
      })
    },
    Category (val, title) {
      this.cid = val
      this.title = title
      this.dialogTableVisible = true
    },
    select_token (val, name) {
      this.token = val
      this.token_name = name
      this.$confirm('你正在选择使用「' + name + '-USDT」支付，请确保您会使用该支付方式。', '提醒', {
        confirmButtonText: '老司机',
        cancelButtonText: '取消',
        lockScroll: false,
        type: 'warning'
      }).then(() => {
        this.$alert('付款时请务必分毫不差付款二维码上方显示的金额，如果到账金额少于应付金额补足尾款亦可开通。', '提醒', {
          confirmButtonText: '我知道了',
          center: true,
          showClose: false,
          lockScroll: false,
          callback: action => {
            this.loadqr = false
            this.gettokenQR()
            this.dialogTableVisible = false
            this.paydialogTableVisible = true
            this.loading = true
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
  .qr_card___2sKl3 {
    background: #fff;
    margin:0 auto;
    padding: 1rem;
    border-radius: 0.75rem;
    box-shadow: 0 0 14px 6px rgb(0 0 0 / 5%);
    text-align: center;
    display: flex;
    width: 200px;
    height: 200px;
    justify-content: center
  }
  .des{
    text-align: center;
    padding: 10px;
    color: #777;
    font-size: 14px;
    font-weight: 300;
  }
  .text-dark {
    font-weight: 600 !important;
    margin-top: .5rem !important;
    margin-bottom: .5rem !important;
    font-size: 14px;
  }

  .m2 {
    margin-bottom: .5rem;
    margin-top: .5rem;
    font-size: 14px
  }

  .container___rRDCW {
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
  }
  .select_card___3LVj_ .left___3KHaw {
    padding: 20px;
    border-right: 1px solid #fff;
  }
  .select_card___3LVj_ {
    cursor: pointer;
    transition: all .3s;
    display: flex;
    border-radius: 10px;
    background: #F5F5F5;
    margin-bottom: 1.25rem;
  }
  .container___rRDCW .body___3IrP1 {
    margin-bottom: 30px;
  }

  .select_card___3LVj_ .right___1QBlH {
    padding: 20px;
    flex: 4 1;
    font-size: 1.125rem;
    font-weight: 500;
    color: rgba(48,49,51,.85);
  }
  .select_card___3LVj_ .right___1QBlH .description___15tno {
    font-weight: 300;
    color: #aaa;
    font-size: 12px;
  }
  .container___rRDCW .body___3IrP1 {
    margin-bottom: 30px;
  }

  .select_card___3LVj_ .left___3KHaw .icon___2T6Ak {
    width: 45px;
    height: 45px;
    border-radius: 100%;
  }

  .svg-icon {
    width: 45px;
    height: 45px;
  }
  .select_card___3LVj_:hover {
    transform: translateY(-10px);
    box-shadow: 0 .8rem 1.5rem hsla(0,0%,95%,.3)
  }
  .p4 {
    font-size: 15px;
    color: #f39;
    padding-top: 5px;
  }
  .p5 {
    font-size: 14px;
    color: #000000;
    padding-top: 5px;
  }
  .text-dark-usdt {
    text-align: center;
    font-weight: 600 !important;
    margin-top: 0rem !important;
    margin-bottom: 0rem !important;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/paytoken.vue